import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-themes-wrapper',
  imports: [],
  templateUrl: './themes-wrapper.component.html',
  styleUrl: './themes-wrapper.component.scss'
})
export class ThemesWrapperComponent {
  @Input() themes: any[] = [];
}
